import { Pagination } from '@components';
import { useAppDispatch, useAppSelector } from '@hooks';
import { Box, styled } from '@mui/material';
import { getTableBlockData, setOffset } from '@store/table/table.slice';
import { breakpoints } from '@themes/theme.helpers';
import { useEffect } from 'react';

const StyledBox = styled(Box)`
  ${breakpoints.up('md')} {
    margin-top: -17px;
  }
`;

type PaginationProps = {
  id: string;
  totalCount: number;
  itemsPerPage: number;
  isWorking: boolean;
  start: number;
};

export const TablePagination = ({
  id,
  start,
  itemsPerPage,
  isWorking,
  totalCount,
}: PaginationProps) => {
  const dispatch = useAppDispatch();
  const { offset } = useAppSelector(getTableBlockData(id));

  useEffect(() => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const currentPage = offset / itemsPerPage + 1;

    if (currentPage > totalPages && totalPages > 0) {
      const newOffset = (totalPages - 1) * itemsPerPage;
      dispatch(setOffset({ id, offset: newOffset }));
    }
  }, [totalCount, itemsPerPage, offset, dispatch, id]);

  const gotoPrevPage = () => {
    let newOffset = start - itemsPerPage;
    if (newOffset < 0) {
      newOffset = 0;
    }
    dispatch(setOffset({ id, offset: newOffset }));
  };

  const gotoNextPage = () => dispatch(setOffset({ id, offset: start + itemsPerPage }));

  return (
    <StyledBox>
      <Pagination
        start={start}
        onPrev={gotoPrevPage}
        onNext={gotoNextPage}
        isWorking={isWorking}
        totalCount={totalCount}
        itemsPerPage={itemsPerPage}
      />
    </StyledBox>
  );
};
